// hooks/useConnectionData.js
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

/**
 * Hook to get connection by ID with automatic updates
 */
export const useThreadByID = (threadID) => {
  return useSelector(state => {
    if (!threadID) return null;
    const threadData = state.threadData?.data || [];
    return threadData.find(thr => thr.ThreadID == threadID)
  });
};